<div  class="history-modal" id="printWeeklyHistory">
  <div class="main">
  <h1>Weekly History for:</h1>

  <ion-row class="row-space-between">
    <ion-col size="6">
     <div class="emp-data">

        <ion-row>
          <ion-col size="2">
            <span>{{employee.customerCode}}</span>
          </ion-col>
          <ion-col size="8">
            <span>{{employee.customerName}}</span>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="2">
            <span>{{employee.departmentCode}}</span>
          </ion-col>
          <ion-col size="8">
            <span>{{employee.departmentName}}</span>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="2">
            <span>{{employee.employeeCode}}</span>
          </ion-col>
          <ion-col size="8">
            <strong class="title">{{employee.lastName}}, {{employee.firstName}}</strong>
          </ion-col>
        </ion-row>
      </div>
    </ion-col>

    <ion-col size="6" class="right-align">
      <div class="week-of">
        <div>
        <strong >Report Date:</strong></div>
       <div> <span>{{today | date:'MM/dd/yyyy'}}</span></div>
     <div>
          <button class=" hidden-for-print"
                  style="color: blue; text-decoration: underline; cursor: pointer; font-size: 16px"
                  (click)="changePrinterView('printWeeklyHistory')">
              Print
          </button>
     </div>

        <div class="loading-container" style="padding-top: 15%; padding-right:90%" *ngIf="!loaded">
          <ion-spinner></ion-spinner>
        </div>
      </div>
    </ion-col>
  </ion-row>
</div>

  <ion-grid>
  <ion-row class="grid-title">
    <ion-col>Week of:</ion-col>
    <ion-col *ngFor="let category of categories">{{ category }}</ion-col>
  </ion-row>

  <ion-row *ngFor="let week of weeklyHistory" class="alternate">
    <ion-col>{{ week.week | date:'MM/dd/yyyy' }}</ion-col>
    <ion-col *ngFor="let category of categories">{{ week[category] }}</ion-col>
  </ion-row>
</ion-grid>
</div>
